module.exports = __webpack_public_path__ + "static/eye-c699be75888865be0ab842233bd25ec4.gif";